import clsx from "clsx";

const variantClassMapping = {
  light: { filled: "bg-surface-primary", empty: "bg-surface-secondary" },
  dark: {
    filled: "bg-surface-primary-inverse",
    empty: "bg-surface-secondary-inverse",
  },
};

export interface DireProgressBarProps {
  /** Percentage filled, 0-100. Omit to render a fully empty bar. */
  value?: number;
  /** Light-on-dark, for bars sitting on an aubergine surface. */
  inverted?: boolean;
  className?: string;
}
// TODO: rename once the 'old ProgressBar' is removed

/**
 * Matches the dire-progressbar design-system component: two rounded segments
 * separated by a small gap, not a single bar with a width overlay.
 */
export const DireProgressBar = ({
  value,
  inverted = false,
  className,
}: DireProgressBarProps) => {
  const filled =
    value !== undefined && Number.isFinite(value)
      ? Math.min(100, Math.max(0, value))
      : 0;
  const variantClasses = variantClassMapping[inverted ? "dark" : "light"];

  return (
    <div
      data-testid="usage-bar"
      className={className ?? "flex h-1 w-full items-start gap-0.5"}
    >
      <div
        data-testid="usage-bar-fill"
        className={clsx("h-full rounded-full", variantClasses.filled)}
        style={{ flexGrow: filled, flexBasis: 0 }}
      />
      <div
        data-testid="usage-bar-empty"
        className={clsx("h-full rounded-full", variantClasses.empty)}
        style={{ flexGrow: 100 - filled, flexBasis: 0 }}
      />
    </div>
  );
};
